
    import { Component, Mixins, Vue } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import moment from 'moment';
    import Log from '@/types/Log';
    import { GridConfig, GridFilters } from '@/types';
    import { ListItems, VGrid } from '@/types/Components';
    import { Priority } from '@/types/Logbuch';
    import { LogsFilter } from '@/store/types';
    import GridResize from '@/mixins/GridResize';

    @Component({
        computed: {
            ...mapState('logs', ['filter']),
        },
    })
    export default class JawaLogbuch extends Mixins(Vue, GridResize) {
        public $refs!: {
            grid: VGrid<Log>;
        };

        public filter!: LogsFilter;

        public eintrag: Log | null = null;
        public zeitraumMenu = false;

        public readonly loglevel: ListItems<Priority> = [
            { text: 'Emergency', value: Priority.Emerg },
            { text: 'Alert', value: Priority.Alert },
            { text: 'Critical', value: Priority.Crit },
            { text: 'Error', value: Priority.Err },
            { text: 'Warning', value: Priority.Warn },
            { text: 'Notice', value: Priority.Notice },
            { text: 'Info', value: Priority.Info },
            { text: 'Debug', value: Priority.Debug },
        ];

        public get gridConfig(): GridConfig<Log> {
            return {
                id: 'logs',
                title: 'Logs',
                class: Log,
                remote: '/logs',
                headers: [
                    {
                        value: 'timestamp',
                        text: 'Zeitstempel',
                        width: 175,
                    },
                    {
                        value: 'extra_user_id',
                        text: 'Benutzer',
                        width: 220,
                    },
                    {
                        value: 'priority',
                        text: 'Priorität',
                        width: 120,
                    },
                    {
                        value: 'actions',
                        text: '',
                        sortable: false,
                        width: 50,
                    },
                    {
                        value: 'message',
                        text: 'Nachricht',
                    },
                ],
            };
        }

        public get filters(): GridFilters<Log> {
            const [minZeitraum, maxZeitraum] = [...this.filter.zeitraum].sort((a, b) => a.localeCompare(b));

            return [
                {
                    property: 'timestamp',
                    operator: 'between',
                    type: 'date',
                    value: {
                        min: minZeitraum,
                        max: maxZeitraum,
                    },
                },
                {
                    property: 'priority',
                    operator: 'in',
                    value: this.filter.loglevel,
                },
            ];
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get zeitraumLabel(): string {
            return this.filter.zeitraum.length
                ? [...this.filter.zeitraum].sort((a: string, b: string) => a.localeCompare(b)).map((date: string) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' - ')
                : '';
        }

        public getLoglevelName(item: Log): string {
            return this.loglevel.find(({ value }) => value === item.priority)?.text ?? '';
        }

        public onClickFiltern(): void {
            this.$refs.grid.load(true);
        }

        public onLoadStorageFilters(filters?: GridFilters<Log>): void {
            (filters ?? []).forEach((filter) => {
                switch (filter.property) {
                    case 'priority':
                        this.filter.loglevel = filter.value ?? [];
                        break;
                }
            });
        }
    }
